import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import useComputedItems from 'hooks/useComputedItems';
export function useComputePlaylistsAudienceAndTeams(_ref) {
  var accessDataItems = _ref.accessDataItems,
    changedAudience = _ref.changedAudience,
    _ref$allowAddingExist = _ref.allowAddingExistingItems,
    allowAddingExistingItems = _ref$allowAddingExist === void 0 ? true : _ref$allowAddingExist;
  var accessDataWithFilteredTeams = accessDataItems.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      teams: item.teams.filter(function (team) {
        return !team.isCalculated;
      })
    });
  });
  var _useComputedItems = useComputedItems({
      allowAddingExistingItems: allowAddingExistingItems,
      getItemId: function getItemId(item) {
        return "".concat(item.team.id, "+").concat(item.playlistId);
      },
      initialItems: accessDataWithFilteredTeams.map(function (playlist) {
        return playlist.teams.map(function (team) {
          return {
            playlistId: playlist.id,
            audience: playlist.audience,
            team: team
          };
        });
      }).flat()
    }),
    itemsToAdd = _useComputedItems.itemsToAdd,
    itemsToRemove = _useComputedItems.itemsToRemove,
    computedItems = _useComputedItems.computedItems,
    addItem = _useComputedItems.addItem,
    removeItem = _useComputedItems.removeItem,
    reset = _useComputedItems.reset,
    wasChanged = _useComputedItems.wasChanged;
  var selectedAudiencesAndTeams = accessDataWithFilteredTeams.map(function (item) {
    var audience = changedAudience || item.audience;
    var playlistTeams = computedItems.filter(function (aAT) {
      return aAT.playlistId === item.id;
    }).map(function (aAT) {
      return _objectSpread(_objectSpread({}, aAT), {}, {
        audience: audience
      });
    });
    if (!playlistTeams.length) {
      return [{
        playlistId: item.id,
        audience: audience,
        team: {
          id: 'null'
        }
      }];
    } else {
      return playlistTeams;
    }
  });
  var teamIdsToAdd = _toConsumableArray(new Set(itemsToAdd.map(function (item) {
    return item.team.id;
  })));
  var teamIdsToRemove = _toConsumableArray(new Set(itemsToRemove.map(function (item) {
    return item.team.id;
  })));
  return {
    wasChanged: wasChanged,
    addItem: addItem,
    removeItem: removeItem,
    reset: reset,
    selectedAudiencesAndTeams: selectedAudiencesAndTeams,
    teamIdsToAdd: teamIdsToAdd,
    teamIdsToRemove: teamIdsToRemove
  };
}
export default useComputePlaylistsAudienceAndTeams;